import { HttpClient } from 'api/http-client';
import type { RevenueConfig } from './types';

const BASE_URL = '/revenue-entries/configuration';

class RevenueConfigApiClient extends HttpClient {
  public getRevenueConfig = (): Promise<RevenueConfig> => {
    return this.get(BASE_URL);
  };

  public updateRevenueConfig = (
    revenueConfig: RevenueConfig,
  ): Promise<RevenueConfig> => {
    return this.put(BASE_URL, revenueConfig);
  };
}

export const RevenueConfigApi = new RevenueConfigApiClient();
